export const userLoggedIn = (data) => {
    // console.log("sent data >> ", data);
    return (dispatch) => {
        dispatch({
            type: "USER_LOGGEDIN",
            payload: data.status,
            token: data.token,
            info: data.userInfo,
        });
    };
};